import { AppShell } from '@/components/shell/AppShell';
import { AuthGuard } from '@/lib/auth/AuthGuard';
import { internalCommands, internalNav } from '@/lib/nav/internal';

export function InternalLayout() {
  return (
    <AuthGuard audience="internal">
      <AppShell audience="internal" nav={internalNav} commands={internalCommands} />
    </AuthGuard>
  );
}
